module.exports = __webpack_public_path__ + "img/a35.16c5b737.svg";